import { AuthProvider } from 'react-admin';

// 因为有fake server，fake server加载成功后fetch会被替换掉，这里我们要保留原始的fetch
// TODO: Remove fetch server and ues the original fetch
const myFetch = fetch;

const isDev = process.env.NODE_ENV === 'development';
const clientId = isDev ? 'Ov23litZWnOeWXls4oM0' : 'Ov23liIGQMrLyaSI1b9T';

const authProvider: AuthProvider = {
    login: async () => {
        window.location.href = `${window.location.origin}/login`;
        // return Promise.resolve({redirectTo: true}); // Wait for redirect
        return new Promise(() => {}); // Wait for redirect
    },
    logout: async (params: any) => {
        localStorage.removeItem('userId');
        localStorage.removeItem('userName');
        // const response = await myFetch('/auth/logout', {
        //     method: 'GET',
        //     headers: {
        //         'Content-Type': 'application/json',
        //     },
        // });
        // if (!response.ok) {
        //     throw new Error(`Failed to logout: ${response.statusText}`);
        // }
        return;
    },
    async checkError(error) {
        const status = error.status;
        if (status === 401 || status === 403) {
            localStorage.removeItem('userId');
            localStorage.removeItem('userName');
            throw new Error();
        }
        // other error code (404, 500, etc): no need to log out
    },
    checkAuth: async () => {
        const { pathname } = window.location;

        const publicPaths = ['/oauth-callback'];

        if (publicPaths.includes(pathname)) {
            return Promise.resolve();
        }

        console.log("checkAuth");

        if (!localStorage.getItem('userId')) {
            console.error("check auth: failed to get userId");
            await authProvider.logout(undefined);
            throw new Error("no userId");
        }

        // const response = await myFetch('/api/v1/users/me', {
        //     method: 'GET',
        //     headers: {
        //         'Content-Type': 'application/json',
        //     },
        // });
        // if (!response.ok) {
        //     throw new Error(`Failed to get user: ${response.statusText}`);
        // }
    },
    getPermissions: () => Promise.resolve(),
    getIdentity: async () => {

        const { pathname } = window.location;
        const publicPaths = ['/oauth-callback'];
        console.log(`getIdentity for path: ${pathname}`);

        if (publicPaths.includes(pathname)) {
            console.log("getIdentity: public path");
            return Promise.resolve({
                id: "",
                fullName: "",
                avatar: "",
                roles: "",
            });
        }

        if (!localStorage.getItem('userId')) {
            console.log("getIdentity: no userId");
            return Promise.reject(new Error("no userid")); // Wait for redirect
        }

        console.log("getIdentity: userId", localStorage.getItem('userId'));
        return Promise.resolve({
            id: localStorage.getItem('userId') || "",
            fullName: localStorage.getItem('displayName') || "",
            avatar: localStorage.getItem('avatar') || "",
        })
    },
};

export default authProvider;
